import { ConfigState, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';

export class ConfigGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.config]: (configState: ConfigState): EmpathyXConfig => {
      return configState.config[configState.device];
    },
    [CONFIG_GETTERS_KEYS.isDocumentLtr]: (configState: ConfigState): boolean => {
      return configState.dynamic.documentDirection === 'ltr';
    }
  };
}
